import { router } from '@inertiajs/vue3';
import { reactive } from 'vue';

export const currentCompany = () => {
    return router.page.props.currentCompany;
};

export const stepIsCompleted = (step) => {
    return !!currentCompany().setup_steps[step]?.completed_at;
};

export const stepIsInProgress = (step) => {
    return !!currentCompany().setup_steps[step]?.in_progress;
};

export const setupFinished = () => {
    return !!currentCompany().setup_finished_at
};

export const step = reactive({
    name: null,
    isCompleting: false,

    complete () {
        if (this.isCompleting) {
            return;
        }

        this.isCompleting = true;

        setTimeout(() => {
            axios.post(`/kund/${currentCompany().slug}/completed-step`, {
                step: this.name,
            }).then(response => {
                if (response.data.next_step_url) {
                    router.visit(response.data.next_step_url, {
                        onSuccess: () => {
                            this.isCompleting = false;
                        }
                    });
                }
            }).catch(err => {
                this.isCompleting = false;
            });
        }, 300);
    },

    isCompleted () {
        return stepIsCompleted(this.name);
    }
});
